// Build-time injected via Vite. For S3-hosted SPA we instead fetch /config.json at runtime.
export interface AppConfig {
  region: string;
  userPoolId: string;
  userPoolClientId: string;
  hostedUiDomain: string;       // e.g. https://gasgavel-abc.auth.us-west-2.amazoncognito.com
  appDomain: string;            // e.g. gasgavel.qik2.app
  apiBase: string;              // same-origin /api when CloudFront fronts API; else direct API URL
  enableGoogleIdp?: boolean;    // show "Continue with Google" button
  enableAppleIdp?: boolean;     // show "Sign in with Apple" button
}

let cached: AppConfig | null = null;

export async function loadConfig(): Promise<AppConfig> {
  if (cached) return cached;
  const r = await fetch('/config.json', { cache: 'no-store' });
  if (!r.ok) throw new Error('config.json missing — bootstrap the deploy');
  cached = await r.json();
  return cached!;
}
